document.addEventListener('DOMContentLoaded', () => {
  const productInformationSections = document.querySelectorAll('.product-information');

  productInformationSections.forEach((section) => {
    const mediaArea = section.querySelector('.product-information__media');
    const slideshow = mediaArea?.querySelector('slideshow-component');
    const customControlContainers = section.querySelectorAll('.custom-control-container');

    if (!slideshow || !customControlContainers.length) return;

    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide')).filter((slide) => !slide.hasAttribute('hidden'));
    if (slides.length <= 1) return;

    let currentIndex = 0;

    customControlContainers.forEach((container) => {
      container.innerHTML = '';

      slides.forEach((_, index) => {
        const customButton = document.createElement('button');
        customButton.type = 'button';
        customButton.classList.add('custom-control-button');

        if (index === 0) {
          customButton.classList.add('active');
        }

        customButton.addEventListener('click', () => {
          selectSlide(index);
          restartBuiltInAutoplay();
        });

        container.appendChild(customButton);
      });
    });

    function updateCustomControls(index) {
      customControlContainers.forEach((container) => {
        container.querySelectorAll('.custom-control-button').forEach((button, buttonIndex) => {
          button.classList.toggle('active', buttonIndex === index);
        });
      });
    }

    function selectSlide(index) {
      currentIndex = index;

      if (typeof slideshow.select === 'function') {
        slideshow.select(index);
      }

      updateCustomControls(index);
    }

    slideshow.addEventListener('slideshow:select', (event) => {
      const index = event.detail?.index;
      if (typeof index !== 'number') return;

      currentIndex = index;
      updateCustomControls(index);

      if (event.detail?.userInitiated) {
        restartBuiltInAutoplay();
      }
    });

    function restartBuiltInAutoplay() {
      const autoplay = parseInt(slideshow.getAttribute('autoplay') || '', 10);
      if (Number.isNaN(autoplay) || autoplay <= 0) return;
      if (typeof slideshow.suspend === 'function') {
        slideshow.suspend();
      }
      if (typeof slideshow.play === 'function') {
        slideshow.play();
      }
    }
  });
});
